import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Expand = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27.707 15.293L23.707 11.293C23.526 11.112 23.276 11 23 11C22.448 11 22 11.448 22 12C22 12.276 22.112 12.526 22.293 12.707L24.586 15H17V7.414L19.293 9.707C19.474 9.888 19.724 10 20 10C20.552 10 21 9.552 21 9C21 8.724 20.888 8.474 20.707 8.293L16.707 4.293C16.526 4.112 16.276 4 16 4C15.724 4 15.474 4.112 15.293 4.293L11.293 8.293C11.112 8.474 11 8.724 11 9C11 9.552 11.448 10 12 10C12.276 10 12.526 9.888 12.707 9.707L15 7.414V15H7.414L9.707 12.707C9.888 12.526 10 12.276 10 12C10 11.448 9.552 11 9 11C8.724 11 8.474 11.112 8.293 11.293L4.293 15.293C4.112 15.474 4 15.724 4 16C4 16.276 4.112 16.526 4.293 16.707L8.293 20.707C8.474 20.888 8.724 21 9 21C9.552 21 10 20.552 10 20C10 19.724 9.888 19.474 9.707 19.293L7.414 17H15V24.586L12.707 22.293C12.526 22.112 12.276 22 12 22C11.448 22 11 22.448 11 23C11 23.276 11.112 23.526 11.293 23.707L15.293 27.707C15.474 27.888 15.724 28 16 28C16.276 28 16.526 27.888 16.707 27.707L20.707 23.707C20.888 23.526 21 23.276 21 23C21 22.448 20.552 22 20 22C19.724 22 19.474 22.112 19.293 22.293L17 24.586V17H24.586L22.293 19.293C22.112 19.474 22 19.724 22 20C22 20.552 22.448 21 23 21C23.276 21 23.526 20.888 23.707 20.707L27.707 16.707C27.888 16.526 28 16.276 28 16C28 15.724 27.888 15.474 27.707 15.293Z" />
	</svg>
);

export default Expand;
